module.exports = __webpack_public_path__ + "img/horizontal_4_6_8023.70a8b276.png";